import {useMutation} from "@tanstack/react-query";
import {updateExpedientMutationOptions} from "./update-expedient.mutation-options";

export function useUpdateExpedient(id: string) {
  return useMutation(updateExpedientMutationOptions(id));
}
